import { AzureApplicationAvatar } from "@/components/azure-application-avatar/azure-application-avatar";
import { ImplementedAccessorColumnDef } from "@/components/data-table/types";
import i18next from "i18next";
import { Check } from "lucide-react";
import { components } from "../../../api-schema";
import { ApplicationV1Enum } from "../../../api-schema-enums";
import { commonColumns } from "./_constants/common-columns";

export type ApplicationTableType = components["schemas"]["Application"];

export const applicationTableDefaultColumns = {
  columnImage: {
    id: "image",
    size: 60,
    enableSorting: false,
    header: () => i18next.t("common:Image"),
    accessorFn: (row) => row,
    cell: ({ row }) => {
      return <AzureApplicationAvatar name={row.original.name} uuid={row.original.azureObjectUuid} />;
    },
  } as ImplementedAccessorColumnDef<ApplicationTableType>,
  columnName: {
    ...commonColumns.columnName<ApplicationTableType>(),
    size: 500,
    header: () => i18next.t("ram:Apps"),
  } as ImplementedAccessorColumnDef<ApplicationTableType>,
  columnIsV1Application: {
    id: "isV1Application",
    size: 100,
    enableSorting: true,
    header: () => i18next.t("common:IsV1App"),
    accessorFn: (row): ApplicationV1Enum => row.isV1Application,
    cell: (cell) => {
      const value = cell.getValue();
      return value === ApplicationV1Enum.IsV1 ? <Check className="h-4 w-4" /> : null;
    },
  } as ImplementedAccessorColumnDef<ApplicationTableType, ApplicationV1Enum>,
  columnUuid: commonColumns.columnUuid<ApplicationTableType>(),
  columnCreatedAt: commonColumns.columnCreatedAt<ApplicationTableType>(),
  columnUpdatedAt: commonColumns.columnUpdatedAt<ApplicationTableType>(),
};
